import { Text } from 'src/Components'

import styles from './ThingsToNoteItem.module.scss'

export interface ThingsToNoteItemProps {
  img: string
  alt: string
  note: string
}

export const ThingsToNoteItem = ({ note, img, alt }: ThingsToNoteItemProps) => {
  return (
    <div className={styles.item}>
      <img src={img} alt={alt} />
      <Text element='p' variant='neutralCool' variantCount='900' align='left'>
        {note}
      </Text>
    </div>
  )
}
